import React from "react";
import Byj from "../assets/images/yd_byj.png";


const ByjDetails = () => {
  return (
    <section className="team-details">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-lg-5">
            <div className="team-details__content">
              <h2 className="team-details__title">移动摆药机</h2>
              <h3 className="team-details__subtitle" style={{ fontWeight: "bold" }}>设计理念</h3>
              <strong style={{ color: "black" }}>产品特点 </strong>
              结构简单、耐用、可靠。设计原理上就将故障发生的可能性降到最低。<br/>
              部件选用上遵循“大马拉小车”的原则，保证部件寿命的足够设计冗余，以满足医院这一特殊用户群体的无故障要求。<br/>
              模块化设计，手自动模式独立控制，保证药品的存取安全。<br/>
              所有子系统均要满足软件硬件double-check的原则，以保证系统的稳定可靠杜绝故障的发生。<br/>
              <br/>
              <br/>
              <strong style={{ color: "black" }}>设计理念： </strong>
              结构简单、耐用、可靠。设计原理上就将故障发生的可能性降到最低。<br/>
              部件选用上遵循“大马拉小车”的原则，保证部件寿命的足够设计冗余，以满足医院这一特殊用户群体的无故障要求。<br />
            </div>
          </div>
          <div className="col-lg-6">
            {/* <h3 style={{color:"black"}}>运用场景</h3> */}
            <h2 className="team-details__title">运用场景</h2>
            <p className="team-details__text">
            药师可通过智能移动排药系统来操作智能针剂存储发放系统发放领用的各类包装形式的药品。</p><br />
            <div className="team-one__single">
              <div className="course-one__image">
                <img src={Byj} alt="" />
              </div>

              <div className="team-one__content">
                <h2 className="team-one__name">
                  <a href="/byj-details">智能移动摆药机</a>
                </h2>
                <p className="team-one__designation">苏州卫捷</p>
              </div>
              <div className="team-one__social">
                <a href="#none">
                  <i className="fab "></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ByjDetails;
